var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "角色权限分配",
        visible: _vm._dialogVisible,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm._dialogVisible = $event
        },
      },
    },
    [
      _c("el-tree", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.dataLoading,
            expression: "dataLoading",
          },
        ],
        attrs: {
          data: _vm.dataList,
          "show-checkbox": "",
          "node-key": "id",
          "default-checked-keys": _vm.checkedResourcesId,
          props: _vm.defaultProps,
          "default-expand-all": "",
        },
        on: { check: _vm.handleCheck },
      }),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm._dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.btnLoading,
                size: "small",
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }